module.exports = "<div class=block-ui-overlay> </div> <div class=block-ui-message-container> <div class=block-ui-message> <div class=loader>Loading...</div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./client/app/blockUI.html
// module id = 314
// module chunks = 0